export default (Vue) => {
  // ajax配置
  Vue.prototype.$hasPerm = (permission) => {
    const permissions = localStorage.getItem('permissions');
    permission = `"permissionCode":"${permission}"`;
    if (!permissions) {
      return false;
    }
    return permissions.indexOf(permission) > -1;
  };

  Vue.prototype.$account = () => {
    const account = localStorage.getItem('account');
    if (!account) {
      return {};
    }
    return JSON.parse(account);
  };

  Vue.prototype.$partA = () => {
    const account = localStorage.getItem('account');
    if (!account) {
      return {};
    }
    return JSON.parse(account).companyType === 'party_a';
  };

  Vue.prototype.$partB = () => {
    const account = localStorage.getItem('account');
    if (!account) {
      return {};
    }
    return JSON.parse(account).companyType === 'party_b';
  };
  Vue.prototype.$collectible = () => {
    const account = localStorage.getItem('account');
    if (!account) {
      return {};
    }
    return (JSON.parse(account).businessType === 'collection' || JSON.parse(account).businessType === 'collection-two');
  };
};



// WEBPACK FOOTER //
// ./src/utils/auth.js